import LinearProgress from '@material-ui/core/LinearProgress';
//------------Material UI------------//
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useContext, useMemo, useRef, useState } from 'react';
import { Route, Router } from 'react-router-dom';
import { useQuery, useQueryClient } from 'react-query';
//import SideNav, { Toggle, Nav, NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '../.././react-sidenav.css';
//import { Switch } from '@material-ui/core';
import basePCUrl from '../../Globals';
//create font awesome library
import initFontAwesome from '../../utils/initFontAwesome';
import usePortalAuth from '../../auth/usePortalAuth';
import AccountInfo from './AccountInfo/AccountInfo';
import Alerts from './Alerts/Alerts';
import AlertsDetail from './Alerts/AlertsDetail';
import Billing from './Billing/Billing';
//import CompanyOverview from './CompanyInfo/OldCompanyOverview';
import Callback from '../Callback';
import CompanyOverviewSwitch from './CompanyInfo/CompanyOverviewSwitch';
import CompanyAdminOverview from './CompanyInfo/CompanyAdminOverview';
import CompanyConfiguration from './Configuration/CompanyConfiguration';
import Configuration from './Configuration/Configuration';
import useStickyState from './CustomHooks/useStickyState';
import './Dashboard.css';
import Install from './Downloads/Downloads';
import Error from './Error/Error';
import ErrorUserNotFound from './Error/ErrorUserNotFound';
import GettingPermissionsMessage from './GettingPermissionsMessage/GettingPermissionsMessage';
import history from './history';
import AboutPhishCloud from './Information/AboutPhishCloud';
import ContactUs from './Information/ContactUs';
import Layout from './Layout/Layout';
import LinkAnalysis from './LinkAnalysis/LinkAnalysis';
import LinkAnalysisAdmin from './LinkAnalysis/LinkAnalysisAdmin';
import LinkSafetyRules from './LinkSafetyRules/LinkSafetyRules';
import MSSPBaseView from './MSSP/MSSPBaseView';
import AccountAdminRoute from './Routes/AccountAdminRoute';
import AdminRoute from './Routes/AdminRoute';
import PrivateRoute from './Routes/PrivateRoute';
import SideNav from './SideNav/SideNav';
import SideNavMobile from './SideNav/SideNavMobile';
import Training from './Training/Training';
import TrainingItemView from './Training/TrainingItemView';
import TrainingNew from './Training/TrainingNew';
import TrainingQuiz from './Training/TrainingQuiz/TrainingQuiz';
import TeamTrainingReport from './Training/TeamTrainingReport';
import UserTrainingDashboard from './Training/UserTrainingDashboard';
import AdminTrainingDashboard from './Training/AdminTrainingDashboard';
import TrainingDashboardSwitch from './Training/TrainingDashboardSwitch';
import MinimalTrainingUberTabs from './Training/MinimalTrainingUberTabs';
import RestructuredUserLinkHistory from './UserLinkHistory/RestructuredUserLinkHistory';
import UserManagement from './UserManagement/UserManagement';
import WelcomeLandingPage from './WelcomeLandingPage/WelcomeLandingPage';
import ScalableShieldSpinner from './LoadingSpinner/ScalableShieldSpinner';
import { fetchApiData, fetchOldApiData, postApiData } from '../../utils/service';
import { getStoredAccessToken } from '../../auth/pcAuthBrowserFlow';
import { buildSearchableKeyVariants, normalizeTranslationKey } from '../../utils/translationKeyContract';
import { isPseudoLocalizationLanguage, pseudoLocalizeText } from '../../utils/pseudoLocalization';
import {
  trackTranslationMiss,
  trackTranslationRequestFailure,
  trackTranslationRequestSuccess,
} from '../../utils/translationTelemetry';

//-----------Testing Product Intro----------//
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

//----------Product Intro----------//
//import AdminConfigSteps from './ProductIntro/AdminConfigSteps';
import './ProductIntro/ProductTourSlides.css';

import ProductTourSlides from './ProductIntro/ProductTourSlides';
import { TourProvider } from '@reactour/tour';
import { useTour } from '@reactour/tour';

import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import UserFlowSteps from './ProductIntro/UserFlowSteps';
import AdminConfigSteps from './ProductIntro/AdminConfigSteps';
import UserConfigsSteps from './ProductIntro/UserConfigsSteps';
import { ContactsOutlined, ContactSupportOutlined } from '@material-ui/icons';
import RedirectOnNotFound from './RedirectOnNotFound';
//import { nodeName } from 'jquery';
initFontAwesome();
const componentMap = {
  User: PrivateRoute,
  CompanyAdmin: AdminRoute,
  AccountAdmin: AdminRoute,
};

const RUNTIME_TRANSLATION_CACHE_KEY = 'pc-runtime-translation-cache-v1';
const RUNTIME_TRANSLATION_CACHE_TTL_MS = 1000 * 60 * 30;
const Dashboard = (props) => {
  const { isLoading, isAuthenticated, getAccessTokenSilently } = usePortalAuth();
  const queryClient = useQueryClient();
  let preferredLanguage = props.preferredLanguage;

  const [token, setToken] = useState();
  const [pcatClass, setPcatClass] = useState('');
  const [welcomePage, setWelcomePage] = useState(true);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const runtimeTranslationCacheRef = useRef({});
  const runtimeTranslationCacheExpiresAtRef = useRef(0);
  const requestedRuntimeTranslationRef = useRef(new Set());
  const loggedTranslationMissesRef = useRef(new Set());
  const loggedTranslationFailuresRef = useRef(new Set());
  const [, setRuntimeTranslationVersion] = useState(0);

  // const [clientList, setClientList] = useState([
  //   {
  //     clientId: '',
  //     industry: '',
  //     name: 'no client selected',
  //     numberOfUsers: 0,
  //   },
  // ]);
  const [selectedClient, setSelectedClient] = useStickyState(0, 'selected-client');
  //const [defaultClient, setDefaultClient] = useState();

  //-----------Loading----------//
  const loadingStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      marginLeft: '15%',
      //marginTop: 200,
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },
    title: {
      marginLeft: '15%',
      marginTop: 200,
    },
  }));

  const loadingClasses = loadingStyles();

  const darkMode = props.darkMode;
  const toggleDarkMode = props.toggleDarkMode;

  //--------API Calls---------//
  const isNotLoading = !isLoading;


  const portalKey = useQuery(
    ['get_portal_key', isNotLoading, selectedClient],
    async () => {
      const token = await getAccessTokenSilently();
      return fetchApiData(basePCUrl, token, 'get_portal_key', accessLevel, selectedClient);
    },
    { enabled: isNotLoading, selectedClient }
  );

  const portalKeyData = portalKey?.data?.portalKey;
  //console.log(portalKeyData)


  const portalData = useQuery(
    ['get_portal_data', isNotLoading, selectedClient],
    async () => {
      // CORRECT FLOW: JWT auth only for API requests.
      try {
        // 1. Always try JWT authentication first (proper flow)
        const token = await getAccessTokenSilently();
        setToken(token);
        const result = await fetchApiData(basePCUrl, token, 'get_portal_data', accessLevel, selectedClient);

        // 2. Always persist user identity (usid) when API returns a uid for
        // extension/user-context compatibility, not as an API auth source.
        if (result?.user_data?.getPermissions?.uid) {
          const usid = result.user_data.getPermissions.uid;
          localStorage.setItem('usid', usid);
          // Set session anchor on first successful fetch (24h session guarantee)
          if (!localStorage.getItem('session_login_at')) {
            localStorage.setItem('session_login_at', Date.now().toString());
          }
          console.log('✅ User identity persisted');
        } else {
          localStorage.removeItem('usid');
          localStorage.removeItem('usid_expiry');
        }

        return result;
      } catch (jwtError) {
        console.log('JWT auth failed:', jwtError);
        // 3. Check session anchor before wiping identity
        const sessionStart = localStorage.getItem('session_login_at');
        const SESSION_MAX_MS = 24 * 60 * 60 * 1000; // 24 hours
        if (sessionStart && (Date.now() - parseInt(sessionStart, 10)) < SESSION_MAX_MS) {
          // Within 24h session window — preserve identity, just re-throw to trigger retry
          console.log('⏳ Within 24h session window — preserving identity, will retry');
          throw jwtError;
        }
        console.log('❌ No valid auth — session expired, redirecting to login');
        localStorage.removeItem('usid');
        localStorage.removeItem('usid_expiry');
        localStorage.removeItem('session_login_at');
        throw jwtError;
      }
    },
    {
      enabled: isNotLoading && selectedClient !== null && selectedClient !== undefined,
      // Keep data stable during normal interaction and refresh quietly on cadence.
      staleTime: 1000 * 60 * 15, // 15 minutes
      cacheTime: 1000 * 60 * 30, // 30 minutes
      // PREVENT BLANK UI: Keep showing the previous query's data while a new
      // fetch runs (e.g. when selectedClient changes). Without this, data
      // flashes to undefined and Company Overview tables/charts render blank.
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: 1000 * 60 * 15, // 15 minutes
      refetchIntervalInBackground: false,
      // NETWORK RESILIENCE: Retry failed requests
      retry: 2,
      retryDelay: 1000,
      // SUCCESS CALLBACK
      onSuccess: (data) => {
        if (data?.user_data?.getPermissions?.cid && selectedClient === 0) {
          setSelectedClient(data.user_data.getPermissions.cid, 'selected-client');
        }

        // Guard: detect user switch by comparing stored usid to API-returned uid.
        // If they differ, a different user logged in — clear the stale identity.
        // Note: JWT sub (auth system ID) and portal uid are different ID systems
        // and will never match, so we compare portal uid to portal uid.
        const returnedUid = data?.user_data?.getPermissions?.uid;
        if (returnedUid) {
          const storedUsid = localStorage.getItem('usid');
          if (storedUsid && storedUsid !== returnedUid) {
            console.warn('⚠️ User switch detected — clearing previous user identity');
            localStorage.removeItem('usid');
            localStorage.removeItem('usid_expiry');
            localStorage.removeItem('session_login_at');
            // Store the new user's identity immediately
            localStorage.setItem('usid', returnedUid);
            localStorage.setItem('session_login_at', Date.now().toString());
          }
        }
      },
    }
  );

  //console.log(portalData.data)

  //const isPortalLoading = portalData.isLoading;

  const permissions = portalData?.data?.user_data?.getPermissions;

  const accessLevel = portalData?.data?.user_data?.getPermissions?.accessLvl;

  const chosenLanguage = portalData?.data?.user_data?.getUserSettings?.UserLanguage;

  const defaultClient = portalData?.data?.user_data?.getPermissions?.cid;

  const hasTraining = portalData?.data?.user_data?.getPermissions.training;

  const linkHistoryData = portalData?.data?.user_data?.getUserLinkHistory;

  const userBoxData = portalData?.data?.user_data?.getUserBoxStats;

  const trainingData = portalData?.data?.user_data?.userTraining;

  const adminTrainingData = portalData?.data?.training_admin;

  const userSettings = portalData?.data?.user_data?.getUserSettings;

  const adminConfigData = portalData?.data?.company_admin?.adminConfigs;

  const alertData = portalData?.data?.alerts_admin?.getAlertDetails;

  const usernameList =
    portalData?.data?.company_admin?.getUsernameList?.usernameList ??
    portalData?.data?.company_admin?.getUserNameList?.usernameList ??
    [];

  // usid caching now handled in the auth flow above

  // Update PCAT class when usid or token changes
  useEffect(() => {
    const currentUsid = localStorage.getItem('usid');
    const newPcatClass = currentUsid ? currentUsid : token || '';
    setPcatClass(newPcatClass);
  }, [token, portalData?.data?.user_data?.getPermissions?.uid]);

  // Monitor localStorage changes and clear PCAT class if usid is removed
  useEffect(() => {
    const handleStorageChange = () => {
      const currentUsid = localStorage.getItem('usid');
      if (!currentUsid) {
        setPcatClass(''); // Clear PCAT class if usid is removed
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  //  useEffect(() => {

  // }, [props.preferredLanguage]);

  //console.log(props.preferredLanguage)

  useEffect(() => {
    if (props.hasStoredPreferredLanguage) {
      return;
    }

    if (typeof chosenLanguage === 'string' && chosenLanguage.trim() !== '') {
      props.setPreferredLanguage(chosenLanguage.trim().toUpperCase());
    }
  }, [props.hasStoredPreferredLanguage, chosenLanguage, props.setPreferredLanguage]);

  if (portalData?.data?.company_admin) {
    var userClickOverviewData = portalData?.data?.company_admin.getCompanyUserOverview;
    var companyAlertStats = portalData?.data?.company_admin.getCompanyAlertStats;
    var wordCloud = portalData?.data?.company_admin.getWordCloud;
    var userClickActivity = portalData?.data?.company_admin.getCompanyClickStats;
    var mostRecentCompanySafeUnsafeStats = portalData?.data?.company_admin.getLinkActivity;
    var mostRecentGlobalSafeUnsafeStats = portalData?.data?.company_admin.getGlobalLinksSeen;
    var topGlobalBadLinks = portalData?.data?.company_admin.getGlobalDomainList;
    var companyBoxStats = portalData?.data?.company_admin.getCompanyBoxStats;
    var threatModel = portalData?.data?.company_admin.getThreatModel;
  }

  if (portalData?.data?.account_admin) {
    var accountAdminData = portalData?.data?.account_admin;
  }

  const translationData = useQuery(
    ['initialTranslator', isNotLoading],
    async () => {
      const token = await getAccessTokenSilently();
      setToken(token);
      return fetchApiData(basePCUrl, token, 'initialTranslator');
    },
    { enabled: isNotLoading, selectedClient }
  );

  const translateText = async (text, languageCode) => {
    const token = await getAccessTokenSilently();
    const dataForTranslation = {
      textToTranslate: text,
      targetLanguage: languageCode,
    };
    const data = await postApiData(basePCUrl, token, dataForTranslation, 'translateText');
    if (typeof data?.translatedText === 'string' && data.translatedText.trim() !== '') {
      return data.translatedText;
    }

    throw new Error('Translation failed.');
  };

  const normalizeLanguageCode = (languageCode = 'EN') => {
    return String(languageCode)
      .trim()
      .toUpperCase()
      .replace('_', '-');
  };

  const normalizeTranslatorRequestLanguage = (languageCode = 'EN') => {
    const normalizedCode = normalizeLanguageCode(languageCode);
    const requestAliases = {
      EN: 'EN-US',
      'EN-GB': 'EN-US',
      PT: 'PT-PT',
      'PT-BR': 'PT-PT',
      NO: 'NB',
      CN: 'ZH',
      JP: 'JA',
    };
    return requestAliases[normalizedCode] || normalizedCode;
  };

  const languageCodeAliases = {
    EN: ['EN', 'EN-US', 'EN-GB'],
    EL: ['EL', 'GR'],
    KO: ['KO', 'KR'],
    HI: ['HI', 'IN'],
    NB: ['NB', 'NO'],
  };

  const getCandidateLanguageCodes = (languageCode = 'EN') => {
    const normalizedCode = normalizeLanguageCode(languageCode || 'EN');
    const baseCode = normalizedCode.split('-')[0];
    return Array.from(
      new Set([
        normalizedCode,
        baseCode,
        ...(languageCodeAliases[normalizedCode] || []),
        ...(languageCodeAliases[baseCode] || []),
        'EN',
        'EN-US',
        'EN-GB',
      ])
    );
  };

  const findLanguageTranslation = (translations, languageCode) => {
    if (!translations || typeof translations !== 'object') {
      return undefined;
    }

    const normalizedTargetCode = normalizeLanguageCode(languageCode);

    const directMatch = translations[normalizedTargetCode];
    if (typeof directMatch === 'string' && directMatch.trim() !== '') {
      return directMatch;
    }

    const underscoreCode = normalizedTargetCode.replace('-', '_');
    const underscoreMatch = translations[underscoreCode];
    if (typeof underscoreMatch === 'string' && underscoreMatch.trim() !== '') {
      return underscoreMatch;
    }

    const caseInsensitiveMatch = Object.entries(translations).find(([code, value]) => {
      if (typeof value !== 'string' || value.trim() === '') {
        return false;
      }
      return normalizeLanguageCode(code) === normalizedTargetCode;
    });

    return caseInsensitiveMatch ? caseInsensitiveMatch[1] : undefined;
  };

  const translationLookupIndex = useMemo(() => {
    const forwardKeyLookup = new Map();
    const reverseValueLookup = new Map();

    if (translationData.status !== 'success') {
      return { forwardKeyLookup, reverseValueLookup };
    }

    const sourceTranslations = translationData?.data;
    if (!sourceTranslations || typeof sourceTranslations !== 'object') {
      return { forwardKeyLookup, reverseValueLookup };
    }

    const addReverseLookupValue = (languageCode, translatedValue, translationKey) => {
      if (typeof translatedValue !== 'string') {
        return;
      }

      const normalizedText = normalizeTranslationKey(translatedValue);
      if (!normalizedText) {
        return;
      }

      const normalizedLanguageCode = normalizeLanguageCode(languageCode || 'EN');
      if (!reverseValueLookup.has(normalizedLanguageCode)) {
        reverseValueLookup.set(normalizedLanguageCode, new Map());
      }

      const languageLookup = reverseValueLookup.get(normalizedLanguageCode);
      if (!languageLookup.has(normalizedText)) {
        languageLookup.set(normalizedText, translationKey);
      }
    };

    Object.entries(sourceTranslations).forEach(([translationKey, translationEntry]) => {
      buildSearchableKeyVariants(translationKey).forEach((variantKey) => {
        if (!forwardKeyLookup.has(variantKey)) {
          forwardKeyLookup.set(variantKey, translationKey);
        }
      });

      const translations = translationEntry?.translations || translationEntry;

      if (typeof translations === 'string') {
        addReverseLookupValue('EN', translations, translationKey);
        return;
      }

      if (!translations || typeof translations !== 'object') {
        return;
      }

      Object.entries(translations).forEach(([languageCode, translatedValue]) => {
        addReverseLookupValue(languageCode, translatedValue, translationKey);
      });
    });

    return { forwardKeyLookup, reverseValueLookup };
  }, [translationData.status, translationData.data]);

  const resolveTranslationEntry = (rawKey) => {
    if (translationData.status !== 'success') {
      return null;
    }

    const sourceTranslations = translationData?.data;
    if (!sourceTranslations || typeof sourceTranslations !== 'object') {
      return null;
    }

    const keyVariants = buildSearchableKeyVariants(rawKey);
    for (const variantKey of keyVariants) {
      const matchedKey = translationLookupIndex.forwardKeyLookup.get(variantKey);
      if (!matchedKey) {
        continue;
      }

      const matchedEntry = sourceTranslations[matchedKey];
      if (matchedEntry) {
        return {
          key: matchedKey,
          entry: matchedEntry,
        };
      }
    }

    return null;
  };

  const resolveKeyFromLocalizedValue = (rawValue, languageCode) => {
    if (translationData.status !== 'success') {
      return null;
    }

    const normalizedValue = normalizeTranslationKey(rawValue);
    if (!normalizedValue) {
      return null;
    }

    const candidateLanguageCodes = getCandidateLanguageCodes(languageCode || 'EN');
    for (const candidateLanguageCode of candidateLanguageCodes) {
      const normalizedCandidateCode = normalizeLanguageCode(candidateLanguageCode);
      const languageLookup = translationLookupIndex.reverseValueLookup.get(normalizedCandidateCode);
      const matchedKey = languageLookup?.get(normalizedValue);
      if (matchedKey) {
        return matchedKey;
      }
    }

    return null;
  };
  const clearRuntimeTranslationCache = (removePersisted = true) => {
    runtimeTranslationCacheRef.current = {};
    runtimeTranslationCacheExpiresAtRef.current = 0;
    requestedRuntimeTranslationRef.current = new Set();

    if (removePersisted) {
      try {
        sessionStorage.removeItem(RUNTIME_TRANSLATION_CACHE_KEY);
      } catch (_) {}
    }
  };

  const sanitizeRuntimeTranslationEntries = (rawEntries) => {
    if (!rawEntries || typeof rawEntries !== 'object') {
      return {};
    }

    const sanitizedEntries = {};
    Object.entries(rawEntries).forEach(([rawKey, rawTranslations]) => {
      const normalizedKey = normalizeTranslationKey(rawKey);
      if (!normalizedKey || !rawTranslations || typeof rawTranslations !== 'object') {
        return;
      }

      const normalizedTranslations = {};
      Object.entries(rawTranslations).forEach(([languageCode, translatedValue]) => {
        if (typeof translatedValue !== 'string') {
          return;
        }
        const cleanedTranslation = translatedValue.trim();
        if (!cleanedTranslation) {
          return;
        }
        normalizedTranslations[normalizeLanguageCode(languageCode)] = cleanedTranslation;
      });

      if (Object.keys(normalizedTranslations).length > 0) {
        sanitizedEntries[normalizedKey] = normalizedTranslations;
      }
    });

    return sanitizedEntries;
  };

  const persistRuntimeTranslationCache = (entries, expiresAt) => {
    try {
      sessionStorage.setItem(
        RUNTIME_TRANSLATION_CACHE_KEY,
        JSON.stringify({
          expiresAt,
          entries,
        })
      );
    } catch (_) {}
  };

  const ensureRuntimeTranslationCacheFresh = () => {
    const expiresAt = runtimeTranslationCacheExpiresAtRef.current;
    if (!expiresAt) return;

    if (Date.now() >= expiresAt) {
      clearRuntimeTranslationCache();
    }
  };

  const updateRuntimeTranslationCache = (translationKey, languageCode, translatedText) => {
    ensureRuntimeTranslationCacheFresh();

    const normalizedKey = normalizeTranslationKey(translationKey);
    if (!normalizedKey) return;

    const normalizedLanguageCode = normalizeLanguageCode(languageCode);
    const existingEntry = runtimeTranslationCacheRef.current[normalizedKey] || {};
    runtimeTranslationCacheRef.current[normalizedKey] = {
      ...existingEntry,
      [normalizedLanguageCode]: translatedText,
    };

    const newExpiry = Date.now() + RUNTIME_TRANSLATION_CACHE_TTL_MS;
    runtimeTranslationCacheExpiresAtRef.current = newExpiry;
    persistRuntimeTranslationCache(runtimeTranslationCacheRef.current, newExpiry);
    setRuntimeTranslationVersion((prev) => prev + 1);
  };

  const mergeRuntimeTranslationIntoQueryCache = (translationKey, languageCode, translatedText) => {
    queryClient.setQueryData(['initialTranslator', isNotLoading], (currentData) => {
      if (!currentData || typeof currentData !== 'object') {
        return currentData;
      }

      const currentEntry = currentData[translationKey];
      const currentEntryObject =
        currentEntry && typeof currentEntry === 'object' && !Array.isArray(currentEntry)
          ? currentEntry
          : {};
      const currentTranslations =
        currentEntryObject.translations &&
        typeof currentEntryObject.translations === 'object' &&
        !Array.isArray(currentEntryObject.translations)
          ? currentEntryObject.translations
          : {};

      return {
        ...currentData,
        [translationKey]: {
          ...currentEntryObject,
          translations: {
            ...currentTranslations,
            [languageCode]: translatedText,
          },
        },
      };
    });
  };

  useEffect(() => {
    try {
      const rawCache = sessionStorage.getItem(RUNTIME_TRANSLATION_CACHE_KEY);
      if (!rawCache) return;

      const parsedCache = JSON.parse(rawCache);
      const parsedExpiry = Number(parsedCache?.expiresAt);
      if (!Number.isFinite(parsedExpiry) || parsedExpiry <= Date.now()) {
        clearRuntimeTranslationCache();
        return;
      }

      const sanitizedEntries = sanitizeRuntimeTranslationEntries(parsedCache?.entries);
      runtimeTranslationCacheRef.current = sanitizedEntries;
      runtimeTranslationCacheExpiresAtRef.current = parsedExpiry;
      setRuntimeTranslationVersion((prev) => prev + 1);
    } catch (error) {
      console.warn('Unable to hydrate runtime translation cache:', error);
      clearRuntimeTranslationCache();
    }
  }, []);

  const requestRuntimeTranslation = (originalKey, finalKey, languageCode) => {
    const requestLanguageCode = normalizeTranslatorRequestLanguage(languageCode || 'EN');
    if (isPseudoLocalizationLanguage(requestLanguageCode)) {
      return;
    }

    if (requestLanguageCode === 'EN' || requestLanguageCode === 'EN-US' || requestLanguageCode === 'EN-GB') {
      return;
    }

    const requestId = `${finalKey}::${requestLanguageCode}`;
    if (requestedRuntimeTranslationRef.current.has(requestId)) {
      return;
    }
    requestedRuntimeTranslationRef.current.add(requestId);
    const startedAtMs = Date.now();

    translateText(originalKey, requestLanguageCode)
      .then((translatedValue) => {
        const cleanedTranslation = typeof translatedValue === 'string' ? translatedValue.trim() : '';
        if (!cleanedTranslation) {
          requestedRuntimeTranslationRef.current.delete(requestId);
          trackTranslationRequestFailure({
            key: finalKey,
            language: requestLanguageCode,
            source: 'runtime',
            latencyMs: Date.now() - startedAtMs,
            errorMessage: 'empty_translation_response',
          });
          return;
        }

        // If backend returns the source key, keep request unlocked so we can retry later
        // after the async backend translation pipeline has had time to complete.
        if (normalizeTranslationKey(cleanedTranslation) === normalizeTranslationKey(originalKey)) {
          requestedRuntimeTranslationRef.current.delete(requestId);
          trackTranslationRequestFailure({
            key: finalKey,
            language: requestLanguageCode,
            source: 'runtime',
            latencyMs: Date.now() - startedAtMs,
            errorMessage: 'translation_not_ready',
          });
          return;
        }

        updateRuntimeTranslationCache(finalKey, requestLanguageCode, cleanedTranslation);
        mergeRuntimeTranslationIntoQueryCache(finalKey, requestLanguageCode, cleanedTranslation);
        trackTranslationRequestSuccess({
          key: finalKey,
          language: requestLanguageCode,
          source: 'runtime',
          latencyMs: Date.now() - startedAtMs,
        });
      })
      .catch((error) => {
        requestedRuntimeTranslationRef.current.delete(requestId);
        trackTranslationRequestFailure({
          key: finalKey,
          language: requestLanguageCode,
          source: 'runtime',
          latencyMs: Date.now() - startedAtMs,
          errorMessage: error?.message || 'unknown_error',
        });
        if (!loggedTranslationFailuresRef.current.has(requestId)) {
          loggedTranslationFailuresRef.current.add(requestId);
          console.warn('Runtime translation request failed:', {
            key: finalKey,
            language: requestLanguageCode,
            error,
          });
        }
      });
  };

  const getTranslation = (key, languageCode) => {
    if (key === undefined || key === null) return '';
    const originalKey = String(key);
    const normalizedOriginalKey = normalizeTranslationKey(originalKey);
    if (!normalizedOriginalKey) return originalKey;
    const normalizedRequestedLanguageCode = normalizeTranslatorRequestLanguage(languageCode || 'EN');
    if (isPseudoLocalizationLanguage(normalizedRequestedLanguageCode)) {
      return pseudoLocalizeText(originalKey);
    }

    const candidateCodes = getCandidateLanguageCodes(languageCode || 'EN');
    const requestLanguageCode = normalizedRequestedLanguageCode;

    ensureRuntimeTranslationCacheFresh();

    const resolvedTranslation = resolveTranslationEntry(originalKey);
    const resolvedTranslationKey = resolvedTranslation?.key || normalizedOriginalKey;

    if (resolvedTranslation?.entry) {
      const translations = resolvedTranslation.entry?.translations || resolvedTranslation.entry;
      if (typeof translations === 'string' && translations.trim() !== '') {
        return translations;
      }

      for (const candidateCode of candidateCodes) {
        const translatedValue = findLanguageTranslation(translations, candidateCode);
        if (translatedValue) {
          return translatedValue;
        }
      }
    }

    const runtimeLookupKeys = Array.from(
      new Set([resolvedTranslationKey, ...buildSearchableKeyVariants(originalKey)])
    );
    for (const runtimeLookupKey of runtimeLookupKeys) {
      const runtimeTranslations = runtimeTranslationCacheRef.current[runtimeLookupKey];
      if (!runtimeTranslations) {
        continue;
      }

      for (const candidateCode of candidateCodes) {
        const translatedValue = findLanguageTranslation(runtimeTranslations, candidateCode);
        if (translatedValue) {
          return translatedValue;
        }
      }
    }

    // If the incoming text already matches a localized translation value for the
    // active language, return it directly and skip translateText fallback calls.
    if (
      translationData.status === 'success' &&
      requestLanguageCode !== 'EN-US' &&
      requestLanguageCode !== 'EN-GB'
    ) {
      const localizedMatchKey = resolveKeyFromLocalizedValue(originalKey, requestLanguageCode);
      if (localizedMatchKey) {
        const localizedEntry = translationData?.data?.[localizedMatchKey];
        const localizedTranslations = localizedEntry?.translations || localizedEntry;

        for (const candidateCode of candidateCodes) {
          const translatedValue = findLanguageTranslation(localizedTranslations, candidateCode);
          if (translatedValue) {
            return translatedValue;
          }
        }

        return originalKey;
      }
    }

    if (translationData.status === 'success') {
      if (requestLanguageCode !== 'EN-US' && requestLanguageCode !== 'EN-GB') {
        const missId = `${resolvedTranslationKey}::${requestLanguageCode}`;
        if (!loggedTranslationMissesRef.current.has(missId)) {
          loggedTranslationMissesRef.current.add(missId);
          trackTranslationMiss({
            key: resolvedTranslationKey,
            language: requestLanguageCode,
          });
          console.info('Missing translation key - requesting runtime translation:', {
            key: resolvedTranslationKey,
            language: requestLanguageCode,
          });
        }
      }

      requestRuntimeTranslation(originalKey, resolvedTranslationKey, languageCode);
    }

    // Missing from cached dictionary/runtime fallback — return original key for now.
    return originalKey;
  };

  //-------Auth-------//

  //const accessLevel = permissions?.accessLvl;

  //const accessLevel = "CompanyAdmin"

  const RouteComponent = accessLevel === 'User' ? PrivateRoute : AdminRoute;

  //console.log(selectedClient)

  return (
    <React.Fragment>
      {/* {translationData.status === 'success' ? ( */}
      <Layout
        isLoading={portalData.isLoading}
        userSettings={userSettings}
        translationData={translationData}
        getTranslation={getTranslation}
        setSelectedClient={setSelectedClient}
        selectedClient={selectedClient}
        accountAdminData={accountAdminData}
        defaultClient={defaultClient}
        toggleDarkMode={props.toggleDarkMode}
        accessLevel={accessLevel}
        darkMode={props.darkMode}
        preferredLanguage={preferredLanguage}
        setPreferredLanguage={props.setPreferredLanguage}
        history={history}
        location={props.location}
        isNotLoading={isNotLoading}
        queryClient={queryClient}
        setPcatClass={setPcatClass}
        setToken={setToken}
      >
        <div id="sideNavBody">
          {accessLevel === undefined ? (
            <span></span>
          ) : (
            <div id="sideNav">
              <SideNav
                training={hasTraining}
                accessLevel={accessLevel}
                history={history}
                location={props.location}
                preferredLanguage={preferredLanguage}
                getTranslation={getTranslation}
                selectedClient={selectedClient}
                accountAdminData={accountAdminData}
                onCollapseChange={setSidebarCollapsed}
              />
            </div>
          )}
        </div>
        <div id="sideNavMobileLandscapeBody">
          {accessLevel === undefined ? (
            <span></span>
          ) : (
            <div id="sideNavMobileLandscape">
              {' '}
              <SideNavMobile
                accessLevel={accessLevel}
                history={history}
                location={props.location}
                preferredLanguage={preferredLanguage}
                getTranslation={getTranslation}
              />{' '}
            </div>
          )}
        </div>

        <div id="dashboardBody" className={sidebarCollapsed ? 'sidebar-collapsed' : ''}>
          {/* {loading ? (
            <div style={{width: '60vw'}}>
            <h3>Loading...</h3>
            <LinearProgress />
            </div>
          ) : (
            <span></span>
          )} */}

          {/* {accessLevel !== undefined && !welcomePage ? ( */}
          {!isLoading && isAuthenticated && accessLevel !== undefined ? (
            <main>
              <Router history={props.history} location={props.location}>
                <RedirectOnNotFound history={props.history} location={props.location} redirectTo="/Dashboard/History">
                  <PrivateRoute
                    path="/Dashboard/Callback"
                    component={(props) => <Callback history={props.history} />}
                  />
                  <PrivateRoute
                    path="/Dashboard/History"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <RestructuredUserLinkHistory
                        isLoading={portalData.isLoading}
                        accessLevel={accessLevel}
                        selectedClient={selectedClient}
                        translationData={translationData}
                        getTranslation={getTranslation}
                        history={props.history}
                        location={props.location}
                        preferredLanguage={preferredLanguage}
                        adminConfigData={adminConfigData}
                        linkHistoryData={linkHistoryData}
                        trainingData={trainingData}
                        hasTraining={hasTraining}
                        userBoxData={userBoxData}
                      />
                    )}
                  />
                  <PrivateRoute
                    accessLevel={accessLevel}
                    path="/Dashboard/AnalyzeLink"
                    component={(props) => (
                      <LinkAnalysis
                        accessLevel={accessLevel}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                      />
                    )}
                  />

                  <AdminRoute
                    path="/Dashboard/AnalyzeLinkAdmin"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <LinkAnalysisAdmin
                        accessLevel={accessLevel}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                      />
                    )}
                  />

                  <AdminRoute
                    path="/Dashboard/LinkSafetyRules"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <LinkSafetyRules
                        accessLevel={accessLevel}
                        selectedClient={selectedClient}
                        defaultClient={defaultClient}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                      />
                    )}
                  />
                  <AdminRoute
                    path="/Dashboard/UserManagement"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <UserManagement
                        accessLevel={accessLevel}
                        selectedClient={selectedClient}
                        defaultClient={defaultClient}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                      />
                    )}
                  />

                  {/* <PrivateRoute
                  path="/Dashboard/Configuration"
                  accessLevel={accessLevel}
                  component={(props) => (
                    <Configuration
                      isLoading={isLoading}
                      accessLevel={accessLevel}
                      selectedClient={selectedClient}
                      defaultClient={defaultClient}
                      history={props.history}
                      location={props.location}
                      toggleDarkMode={toggleDarkMode}
                      darkMode={darkMode}
                      userSettings={userSettings}
                      getTranslation={getTranslation}
                      preferredLanguage={preferredLanguage}
                    />
                  )}
                /> */}

                  <AdminRoute
                    path="/Dashboard/AdminConfiguration"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <CompanyConfiguration
                        adminConfigData={adminConfigData}
                        portalKeyData={portalKeyData}
                        accessLevel={accessLevel}
                        selectedClient={selectedClient}
                        defaultClient={defaultClient}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                      />
                    )}
                  />

                  <PrivateRoute
                    path="/Dashboard/TrainingDashboard"
                    accessLevel={accessLevel}
                    render={(props) => (
                      <MinimalTrainingUberTabs
                        isLoading={portalData.isLoading}
                        accessLevel={accessLevel}
                        selectedClient={selectedClient}
                        defaultClient={defaultClient}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                        trainingData={trainingData}
                        adminTrainingData={adminTrainingData}
                        userClickOverviewData={userClickOverviewData}
                        usernameList={usernameList}
                      />
                    )}
                  />
                  <PrivateRoute
                    path="/Dashboard/AdminTrainingDashboard"
                    accessLevel={accessLevel}
                    render={(props) => (
                      <MinimalTrainingUberTabs
                        isLoading={portalData.isLoading}
                        accessLevel={accessLevel}
                        selectedClient={selectedClient}
                        defaultClient={defaultClient}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                        trainingData={trainingData}
                        adminTrainingData={adminTrainingData}
                        userClickOverviewData={userClickOverviewData}
                        usernameList={usernameList}
                      />
                    )}
                  />

                  <AccountAdminRoute
                    path="/Dashboard/AccountManagement"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <MSSPBaseView
                        accessLevel={accessLevel}
                        history={props.history}
                        location={props.location}
                        accountAdminData={accountAdminData}
                        setSelectedClient={setSelectedClient}
                        selectedClient={selectedClient}
                        defaultClient={defaultClient}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                      />
                    )}
                  />

                  <AdminRoute
                    path="/Dashboard/CompanyOverview"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <CompanyAdminOverview
                        isLoading={portalData.isLoading}
                        accessLevel={accessLevel}
                        selectedClient={selectedClient}
                        defaultClient={defaultClient}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                        userOverviewData={userClickOverviewData}
                        companyAlertStats={companyAlertStats}
                        wordCloud={wordCloud}
                        clickStats={userClickActivity}
                        mostRecentCompanySafeUnsafeStats={mostRecentCompanySafeUnsafeStats}
                        mostRecentGlobalSafeUnsafeStats={mostRecentGlobalSafeUnsafeStats}
                        topGlobalBadLinks={topGlobalBadLinks}
                        companyBoxStats={companyBoxStats}
                        threatModel={threatModel}
                        companyAdminData={portalData?.data?.company_admin}
                        trainingAdminData={portalData?.data?.training_admin}
                        trainingData={trainingData}
                      />
                    )}
                  />

                  <AdminRoute
                    path="/Dashboard/Alerts"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <Alerts
                        alertData={alertData}
                        accessLevel={accessLevel}
                        selectedClient={selectedClient}
                        defaultClient={defaultClient}
                        history={props.history}
                        location={props.location}
                        isLoading={portalData.isLoading}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                        isNotLoading={isNotLoading}
                      />
                    )}
                  />
                  <AdminRoute
                    path="/Dashboard/AlertsDetail"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <AlertsDetail
                        accessLevel={accessLevel}
                        selectedClient={selectedClient}
                        defaultClient={defaultClient}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                      />
                    )}
                  />


                  <AdminRoute
                    path="/Dashboard/AssignTraining"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <Training
                        isLoading={portalData.isLoading}
                        accessLevel={accessLevel}
                        selectedClient={selectedClient}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                        trainingViewType="assign-training"
                        trainingData={trainingData}
                        adminTrainingData={adminTrainingData}
                      />
                    )}
                  />
                  <AdminRoute
                    path="/Dashboard/TrainingReport"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <Training
                        accessLevel={accessLevel}
                        selectedClient={selectedClient}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                        trainingViewType="training-report"
                        trainingData={trainingData}
                        adminTrainingData={adminTrainingData}
                      />
                    )}
                  />

                  <AdminRoute path="/Dashboard/TeamTrainingReport"  accessLevel={accessLevel}
                    render={(props) => (<TeamTrainingReport  accessLevel={accessLevel}
                        selectedClient={selectedClient}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                        trainingViewType="training-report"
                        trainingData={trainingData}
                        adminTrainingData={adminTrainingData}
                        usernameList={usernameList}
                        />  )}
                  />

                  <RouteComponent
                    path="/Dashboard/Training"
                    accessLevel={accessLevel}
                    render={(props) => (
                      <TrainingItemView
                        accessLevel={accessLevel}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                        trainingData={trainingData}
                      />
                    )}
                  />
                  <RouteComponent
                    path="/Dashboard/TrainingQuiz"
                    accessLevel={accessLevel}
                    render={(props) => (
                      <TrainingQuiz
                        accessLevel={accessLevel}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                      />
                    )}
                  />

                  <PrivateRoute
                    path="/Dashboard/Billing"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <Billing
                        accessLevel={accessLevel}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                      />
                    )}
                  />
                  <PrivateRoute
                    path="/Dashboard/Downloads"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <Install
                        accessLevel={accessLevel}
                        history={props.history}
                        location={props.location}
                        getTranslation={getTranslation}
                        preferredLanguage={preferredLanguage}
                      />
                    )}
                  />

                  <PrivateRoute
                    path="/Dashboard/account-info"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <AccountInfo getTranslation={getTranslation} preferredLanguage={preferredLanguage} />
                    )}
                  />
                  <PrivateRoute
                    path="/Dashboard/about-us"
                    accessLevel={accessLevel}
                    component={(props) => (
                      <AboutPhishCloud getTranslation={getTranslation} preferredLanguage={preferredLanguage} />
                    )}
                  />
                  <PrivateRoute
                    path="/Dashboard/contact-us"
                    accessLevel={accessLevel}
                    component={ContactUs}
                    getTranslation={getTranslation}
                    preferredLanguage={preferredLanguage}
                  />
                  <PrivateRoute
                    path="/Dashboard/Error"
                    accessLevel={accessLevel}
                    component={Error}
                    getTranslation={getTranslation}
                    preferredLanguage={preferredLanguage}
                  />
                  <PrivateRoute
                    path="/Dashboard/ErrorUserNotFound"
                    accessLevel={accessLevel}
                    component={ErrorUserNotFound}
                    getTranslation={getTranslation}
                    preferredLanguage={preferredLanguage}
                  />
                  <PrivateRoute
                    path="/Dashboard/chat"
                    accessLevel={accessLevel}
                    getTranslation={getTranslation}
                    preferredLanguage={preferredLanguage}
                    component={() => {
                      window.location.href = 'https://phishcloud.slack.com/archives/CLL45JM09';
                      return null;
                    }}
                  />
                  <Route
                    path="/email"
                    component={() => {
                      window.location.href = 'mailto: support@phishcloud.com';
                      return null;
                    }}
                  />
                </RedirectOnNotFound>
              </Router>
            </main>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh', marginLeft: '-260px', width: 'calc(100% + 260px)' }}>
              <ScalableShieldSpinner
                size={200}
                logoSrc={
                  darkMode
                    ? require('../../Assets/Logos/WhiteShield.png')
                    : require('../../Assets/Logos/Shield.png')
                }
                fullHeight={false}
                darkMode={darkMode}
              />
            </div>
            // <div>  <WelcomeLandingPage setWelcomePage={setWelcomePage} preferredLanguage={preferredLanguage} /></div>
          )}
          {/* {!loading && isAuthenticated === true && !accessLevel ? (
            // <GettingPermissionsMessage preferredLanguage={preferredLanguage} />
            <WelcomeLandingPage setWelcomePage={setWelcomePage} preferredLanguage={preferredLanguage} />
          ) : (
            <div></div>
          )} */}
        </div>
      </Layout>
      {/* // ) : (
      //   <div style={{ position: 'relative', display: 'block' }}>
      //     <div style={{ width: '80vw', height: '80vh', justifyContent: 'center', alignItems: 'center' }}>
      //       <div style={{ marginTop: '25%', marginLeft: '10%' }}>
      //         <h3>Loading...</h3>
      //         <LinearProgress style={{ display: 'block' }} />
      //       </div>{' '}
      //     </div>
      //   </div>
      // )} */}

      {pcatClass && <div id="PCAT" className={pcatClass}></div>}
    </React.Fragment>
  );
};
export default Dashboard;
